/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import PropTypes from 'prop-types';
import {IoIosAddCircleOutline, IoMdCreate, IoMdTrash} from "react-icons/io";

import TextInput from "../BasicInputs/TextInput.jsx";
import Select from "../BasicInputs/Select.jsx";

const options = [{value: "is"}, {value: "isnot"}]


class ConditionsComponent extends React.Component {
    constructor() {
        super();
        this.state = {
            isOpen: false,
            isShowCondition: false


        }
    }

    onToggle = isOpen => {
        this.setState({
            isOpen
        });
    };
    onSelect = (event, selection, isPlaceholder) => {
        this.props.onConditionChange({
            term: {
                a: this.props.condition.term.a,
                type: selection,
                b: this.props.condition.term.b
            },
            True: this.props.condition.True,
            False: this.props.condition.False
        })

        this.setState({
            isOpen: false,
        });
    };


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.condition.hasOwnProperty("defaultValues") && !prevProps.condition.hasOwnProperty("defaultValues") && this.state.isShowCondition === true) {
            this.setState({isShowCondition: false})


        }

    }

    render() {
        return (<>
                {/*if there is a condition on this value than show the button to edit Otherwise the add new one*/}

                {this.props.condition.hasOwnProperty("defaultValues") ? (
                    <>

                        <IoIosAddCircleOutline size={"1.2em"} style={{float: "right", marginTop: -10, zIndex: 1}}
                                               className={"iconLink"}
                                               onClick={() => {
                                                   this.setState({isShowCondition: !this.state.isShowCondition})
                                               }}/>

                    </>
                ) : (<>
                        <IoMdCreate size={"1.2em"} style={{float: "right", marginTop: -10}} className={"iconLink"}
                                    onClick={() => {
                                        this.setState({isShowCondition: !this.state.isShowCondition})
                                    }}/>

                    </>
                )}
                {this.state.isShowCondition && <div>

                    <div style={{border: "3px dashed rgba(28,110,164,0.35)", marginTop: 10, padding: 5}}>
                        <p>Bedingung:</p>

                        <TextInput id="textInput3" aria-label="input with dropdown and button" style={{
                            width: 'calc(35%)',
                            display: "inline-block",
                            BoxShadow: "none",
                            border: "none"

                        }}
                                   value={this.props.condition.term.a}
                                   onChange={event => {
                                       this.props.onConditionChange({
                                           term: {
                                               a: event,
                                               type: this.props.condition.term.type,
                                               b: this.props.condition.term.b
                                           },
                                           True: this.props.condition.True,
                                           False: this.props.condition.False
                                       })
                                   }}
                                   placeholder="---"
                        />


                        <Select
                            chipGroupProps={{numChips: 1, expandedText: "Hide", collapsedText: "Show mohr"}}
                            typeAheadAriaLabel="Select a Table"
                            onToggle={this.onToggle}
                            width={"30%"}
                            onSelect={this.onSelect}
                            selections={this.props.condition.term.type}
                            isOpen={this.state.isOpen}
                            placeholderText="Select a Table"
                            noResultsFoundText={"We couldn't  not found this Table"}
                            options={options}
                            size="1"
                        >

                        </Select>

                        <TextInput id="textInput3" aria-label="input with dropdown and button" style={{
                            width: 'calc(35%)',
                            display: "inline-block",
                            BoxShadow: "none",
                            border: "none"

                        }}
                                   value={this.props.condition.term.b}
                                   onChange={event => {
                                       this.props.onConditionChange({
                                           term: {
                                               a: this.props.condition.term.a,
                                               type: this.props.condition.term.type,
                                               b: event
                                           },
                                           True: this.props.condition.True,
                                           False: this.props.condition.False
                                       })
                                   }}
                                   placeholder="---"
                        />
                    </div>
                    {this.props.standardValuesLooked ? (<>
                        <p>Wahr:</p>
                        {this.props.standardTrueValue}
                        <p>Falsch:</p>
                        {this.props.standardFalseValue}</>) : (<div>
                        <div style={{border: "3px dashed #81ecec", marginTop: 10, padding: 5}}>

                            <p>Wahr:</p>
                            <TextInput id="textInput3" aria-label="input with dropdown and button" style={{
                                width: 'calc(100%)',
                                display: "inline-block",
                                BoxShadow: "none",
                                border: "none"

                            }}
                                       value={this.props.condition.True}
                                       onChange={event => {
                                           this.props.onConditionChange({
                                               term: {
                                                   a: this.props.condition.term.a,
                                                   type: this.props.condition.term.type,
                                                   b: this.props.condition.term.b
                                               },
                                               True: event,
                                               False: this.props.condition.False
                                           })
                                       }}
                                       placeholder="---"
                            />
                        </div>
                        <div style={{border: "3px dashed #fab1a0", marginTop: 10, padding: 5}}>
                            <p>Falsch:</p>

                            <TextInput id="textInput3"
                                       aria-label="input with dropdown and button"
                                       style={{
                                           width: 'calc(100%)',
                                           display: "inline-block",
                                           BoxShadow: "none",
                                           border: "none"

                                       }}
                                       value={this.props.condition.False}
                                       onChange={event => {
                                           this.props.onConditionChange({
                                               term: {
                                                   a: this.props.condition.term.a,
                                                   type: this.props.condition.term.type,
                                                   b: this.props.condition.term.b
                                               },
                                               True: this.props.condition.True,
                                               False: event
                                           })
                                       }}
                                       placeholder="---"
                            /></div>
                        <button variant="link" onClick={() => this.props.onConditionRemove()} color={"#ff7c7c"}
                                icon={<IoMdTrash className={"iconLink"} size={"1.2em"}
                                                 style={{marginBottom: -3, zIndex: 1}} color={"#ff7c7c"}/>}>
                            Remove
                        </button>

                    </div>)}

                </div>}


            </>


        )
    }
}

export default ConditionsComponent

ConditionsComponent.propTypes = {
    allowConditions: PropTypes.bool,
    condition: PropTypes.object,
    onConditionChange: PropTypes.func,
    onConditionRemove: PropTypes.func,
}

ConditionsComponent.defaultProps = {
    condition: {
        term: {a: "", type: "is", b: ""},
        True: "true",
        False: "false",
        defaultValues: true
    }
}